import '@/lib/typedef';
import client from '@/lib/http-client';
import { buildQuery } from '@/lib/helper';

const endpoint = '/wallet';

export default {
	/**
	 * Get Balance
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	getBalance(cb, errorCb, params = {}) {
		const query = buildQuery(params);
		const url = `${endpoint}?${query}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Get Supplier Balance by User ID
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	getSupplierBalance(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/supplier?${query}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Get Service Fee
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	getServiceFee(cb, errorCb) {
		const url = `${endpoint}/service-fee`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Get Commission All Time
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	getCommission(cb, errorCb) {
		const url = `${endpoint}/commission`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Get Handling Fee All Time
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	getHandlingFee(cb, errorCb) {
		const url = `${endpoint}/handling-fee`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Get On Process Withdrawal
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	getOnProcessWithdrawal(cb, errorCb, params = {}) {
		const query = buildQuery(params);
		const url = `${endpoint}/withdrawal/processing?${query}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Get Histories
	 *
	 * @param {Object} params
	 * @param {number} params.limit Limit
	 * @param {'created_at'} params.sort_by Created By
	 * @param {'desc' | 'asc'} params.sort Sort
	 * @param {string} params.page Page
	 * @param {string} [params.keyword] Search Keyword
	 * @param {string} [params.category] Category Tag
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	getHistories(params, cb, errorCb) {
		const url = `${endpoint}/histories`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Get Histories
	 *
	 * @param {Object} params
	 * @param {number} params.limit Limit
	 * @param {'created_at'} params.sort_by Created By
	 * @param {'desc' | 'asc'} params.sort Sort
	 * @param {string} params.page Page
	 * @param {string} [params.keyword] Search Keyword
	 * @param {string} [params.category] Category Tag
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	getAllHistories(params, cb, errorCb) {
		const url = `${endpoint}/histories/all`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Get History by ID
	 *
	 * @param {String|Int} id History ID
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	getHistory(id, cb, errorCb) {
		const url = `${endpoint}/histories/${id}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Update History
	updateHistory(id, params, cb, errorCb) {
		const url = `${endpoint}/histories/${id}`;
		client.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 *
	 * @param {Object} params
	 * @param {string} params.name Tag Name
	 * @param {'contact' | 'product' | 'order' | 'app'} params.category Tag Category
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	withdraw(params, cb, errorCb) {
		const url = `${endpoint}/withdrawal`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 *
	 * @param {Object} id ID
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	delete(id, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client
			.delete(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Add History Meta
	addHistoryMeta(id, params, cb, errorCb) {
		const url = `${endpoint}/histories/${id}/meta`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Export Histories
	 *
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	exportHistories(params, cb, errorCb) {
		const url = `${endpoint}/export`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get Stats (Admin Only)
	getStats(type = 'shipping', params, cb, errorCb, cancelToken) {
		let url = `${endpoint}/stats`;
		if (type === 'claim') url += '/claim';
		client.get(url, { params, cancelToken })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get Wallet Total (Admin Only)
	getWalletTotal(cb, errorCb) {
		const url = `${endpoint}/total`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get Wallet Balance (Admin Only)
	getWalletBalance(cb, errorCb) {
		const url = `${endpoint}/total/users`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get Overviews
	getOverviews(params, cb, errorCb) {
		const url = `${endpoint}/overviews`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get Withdrawal Stats (Admin Only)
	getWithdrawalStats(params, cb, errorCb) {
		const url = `${endpoint}/stats/withdrawals`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Export Withdrawals (to be used on BCA auto transfer)
	exportWithdrawals(params, cb, errorCb) {
		const url = `${endpoint}/export/withdrawals`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};
